import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useParams, useLocation } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import NearbyTrainPositionList from './NearbyTrainPositionList'
import NearbyTrainPositionsFooter from './NearbyTrainPositionsFooter'
import useNearbyIntl from '../../hooks/useNearbyIntl'

const NearbyTrainPositionsApp = (props) => {
  const {
    trains,
    updatedAt,
    themeName,
    fetchTrains,
    fetchJrTrains,
    fetchTokyuTrains,
    fetchUserSettings,
    popinfoId
  } = props

  const { stationId } = useParams()
  const reloadTrains = async () => {
    await fetchTrains()
    if ([8, 9, 10, 28, 29].includes(parseInt(stationId))) { // 西谷、鶴ヶ峰、二俣川駅では新横浜線分岐部分の列車を読み込む
      await fetchJrTrains()
      await fetchTokyuTrains('toyoko')
      await fetchTokyuTrains('meguro')
      await fetchTokyuTrains('shinyokohama')  // K番号補完はfetchTokyuTrains内で実行される
    }
  }

  useEffect(() => {
    const initialize = async () => {
      await fetchUserSettings(popinfoId)
      window.reloadTrains = reloadTrains
      await reloadTrains()
    }

    initialize()

    const intervalId = setInterval(() => {
      reloadTrains()
    }, 45000)

    return () => {
      window.reloadTrains = undefined
      clearInterval(intervalId)
    }
  }, [])

  const { locale, messages } = useNearbyIntl()

  return (
    <IntlProvider locale={locale} messages={messages}>
      <div className={`is_${locale}`}>
        <NearbyTrainPositionList {...props} trains={trains} themeName={themeName} stationId={stationId} />
        <NearbyTrainPositionsFooter updatedAt={updatedAt} themeName={themeName} />
      </div>
    </IntlProvider>
  )
}

NearbyTrainPositionsApp.propTypes = {
  trains: PropTypes.array.isRequired,
  updatedAt: PropTypes.number,
  themeName: PropTypes.string.isRequired,
  fetchTrains: PropTypes.func.isRequired,
  fetchJrTrains: PropTypes.func.isRequired,
  fetchTokyuTrains: PropTypes.func.isRequired,
  fetchUserSettings: PropTypes.func.isRequired,
  popinfoId: PropTypes.string,
}

export default NearbyTrainPositionsApp
